module.exports = __webpack_public_path__ + "img/icon_arrow-right_dark_orange.178d14b4.svg";